import React, { useState } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { ProductCatalog } from './components/ProductCatalog';
import { MeetKylee } from './components/MeetKylee';
import { SizingGuide } from './components/SizingGuide';
import { ReviewsSection } from './components/ReviewsSection';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
import { ProductModal } from './components/ProductModal';
import { CustomOrderModal } from './components/CustomOrderModal';
import { CartDrawer } from './components/CartDrawer';
import { CheckoutModal } from './components/CheckoutModal';
import { Product } from './types';

export const App: React.FC = () => {
  const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);
  const [isSizingModalOpen, setIsSizingModalOpen] = useState(false);
  const [isCustomOrderModalOpen, setIsCustomOrderModalOpen] = useState(false);
  const [isCheckoutOpen, setIsCheckoutOpen] = useState(false);

  const handleExploreClick = () => {
    const shopElem = document.getElementById('shop');
    if (shopElem) {
      shopElem.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-[#FCFAF8] text-[#292524]">
      {/* Top Navbar */}
      <Navbar
        onOpenSizingModal={() => setIsSizingModalOpen(true)}
        onOpenCustomOrderModal={() => setIsCustomOrderModalOpen(true)}
      />

      {/* Main Content Sections */}
      <main className="flex-grow">
        {/* Hero Section */}
        <Hero
          onExploreClick={handleExploreClick}
          onOpenSizingModal={() => setIsSizingModalOpen(true)}
          onOpenCustomOrderModal={() => setIsCustomOrderModalOpen(true)}
        />

        {/* Product Catalog ($30 Each) */}
        <ProductCatalog
          onQuickView={(prod) => setSelectedProduct(prod)}
          onOpenCustomOrderModal={() => setIsCustomOrderModalOpen(true)}
        />

        {/* Meet Kylee (14-Year-Old Gymnast & Artist Story) */}
        <MeetKylee
          onOpenCustomOrderModal={() => setIsCustomOrderModalOpen(true)}
        />

        {/* Interactive Sizing Guide */}
        <SizingGuide />

        {/* Customer Reviews */}
        <ReviewsSection />

        {/* FAQ Section */}
        <FAQSection />
      </main>

      {/* Footer */}
      <Footer
        onOpenSizingModal={() => setIsSizingModalOpen(true)}
        onOpenCustomOrderModal={() => setIsCustomOrderModalOpen(true)}
      />

      {/* Modals & Overlays */}
      {selectedProduct && (
        <ProductModal
          product={selectedProduct}
          onClose={() => setSelectedProduct(null)}
          onOpenSizingModal={() => setIsSizingModalOpen(true)}
        />
      )}

      {isSizingModalOpen && (
        <SizingGuide
          isModal={true}
          isOpen={isSizingModalOpen}
          onClose={() => setIsSizingModalOpen(false)}
        />
      )}

      {isCustomOrderModalOpen && (
        <CustomOrderModal
          isOpen={isCustomOrderModalOpen}
          onClose={() => setIsCustomOrderModalOpen(false)}
        />
      )}

      {/* Slide-Over Shopping Cart Drawer */}
      <CartDrawer
        onCheckoutClick={() => setIsCheckoutOpen(true)}
      />

      {/* Checkout Modal (Stripe Ready + Test Mock) */}
      <CheckoutModal
        isOpen={isCheckoutOpen}
        onClose={() => setIsCheckoutOpen(false)}
      />
    </div>
  );
};
